module.exports = __webpack_public_path__ + "static/media/Banner_chatbots.ccfef6e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/Chatbots_crm/Banner_chatbots.png
// module id = 277
// module chunks = 0